import React from "react";

import "../css/PopupPaymentPointsItem.css";

import { formatCurrency, formatNumber } from "../utils/utils";

export default ({ description, points, currency }) => {
  return (
    <div className="popup-row popup-row-payment-points-item">
      <span className="popup-row-payment-points-item-description">
        {description}:
      </span>
      <span>
        {formatNumber(points)} - {formatCurrency(currency)}
      </span>
    </div>
  );
};
